/**
 * NE4 (.486): Anrufe je Mitarbeiter.
 *
 * ORIGINALTEXT MARVIN (25.10.2026)
 *   „ich will tatsächlich sehen, wer wie viele Gespräche geführt hat ... Damit
 *    ich sehe, wie die Frequenz ist, wie viele Leute tatsächlich angerufen
 *    worden sind, von wem, um die Produktivität zu lokalisieren."
 *
 * Gezählt wird der Klick auf „Anrufen" (Vermerk 'gewaehlt'), daneben das
 * Ergebnis und die am Telefon gebuchten Termine. Ob und wie lange das Gespräch
 * in Webex lief, weiß die Plattform nicht.
 */
import { useEffect, useState } from 'react';
import { api } from '../api.ts';
import { Karte } from './Geruest.tsx';

const heuteTag = () => new Date().toLocaleDateString('sv-SE', { timeZone: 'Europe/Berlin' });
const montagVon = (t: string) => { const d = new Date(t + 'T12:00:00Z'); d.setUTCDate(d.getUTCDate() - ((d.getUTCDay() + 6) % 7)); return d.toISOString().slice(0, 10); };
const tagDe = (t: string) => t ? t.slice(0, 10).split('-').reverse().join('.') : '';
const zahlDe = (n: unknown) => n === null || n === undefined ? '–' : Number(n).toLocaleString('de-DE', { maximumFractionDigits: 1 });
const zeitDe = (s: string | null) => s ? `${tagDe(s.slice(0, 10))} ${s.slice(11, 16)}` : '–';

export function Ne4Anrufe() {
  const [von, setVon] = useState(() => montagVon(heuteTag()));
  const [bis, setBis] = useState(() => heuteTag());
  const [d, setD] = useState<any>(null);
  const [fehler, setFehler] = useState<string | null>(null);
  useEffect(() => {
    let weg = false;
    api.ne4Anrufe(von, bis).then((x) => { if (!weg) { setD(x); setFehler(null); } }).catch((f) => { if (!weg) setFehler(String(f?.message ?? f)); });
    return () => { weg = true; };
  }, [von, bis]);

  const spanne = (art: 'heute' | 'woche' | 'monat') => {
    const h = heuteTag();
    if (art === 'heute') { setVon(h); setBis(h); }
    if (art === 'woche') { setVon(montagVon(h)); setBis(h); }
    if (art === 'monat') { setVon(h.slice(0, 8) + '01'); setBis(h); }
  };
  const personen: any[] = d?.personen ?? [];
  const stunden: any[] = d?.stunden ?? [];
  const namen = [...new Set(stunden.map((s) => s.name as string))];
  const vonStunde = Math.min(8, ...stunden.map((s) => Number(s.stunde)));
  const bisStunde = Math.max(18, ...stunden.map((s) => Number(s.stunde)));
  const spalten = Array.from({ length: bisStunde - vonStunde + 1 }, (_, i) => vonStunde + i);
  const maxStunde = Math.max(1, ...stunden.map((s) => Number(s.wahlen)));

  return (
    <Karte titel="Anrufe je Mitarbeiter" rechts={<span className="klein leise">{tagDe(von)} bis {tagDe(bis)}</span>}>
      <div className="reihe" style={{ flexWrap: 'wrap', gap: 8, marginBottom: 10 }}>
        <button type="button" className="knopf klein" onClick={() => spanne('heute')}>Heute</button>
        <button type="button" className="knopf klein" onClick={() => spanne('woche')}>Diese Woche</button>
        <button type="button" className="knopf klein" onClick={() => spanne('monat')}>Dieser Monat</button>
        <span className="feldpaar"><label className="klein leise" htmlFor="an-von">von</label><input id="an-von" type="date" value={von} onChange={(e) => setVon(e.target.value)} /></span>
        <span className="feldpaar"><label className="klein leise" htmlFor="an-bis">bis</label><input id="an-bis" type="date" value={bis} onChange={(e) => setBis(e.target.value)} /></span>
      </div>
      {fehler && <div className="hinweis fehler">{fehler}</div>}
      {d && !personen.length && <div className="leise klein">In diesem Zeitraum hat niemand über die Anrufliste gewählt.</div>}
      {!!personen.length && (
        <div className="rollt">
          <table className="liste" data-stapeln="nein">
            <thead><tr>
              <th>Mitarbeiter</th><th className="zahl">Wahlen</th><th className="zahl">Kunden</th><th className="zahl">Termine</th><th className="zahl">Quote</th>
              <th className="zahl">nicht erreicht</th><th className="zahl">Rückruf</th><th className="zahl">lehnt ab</th><th className="zahl">falsche Nr.</th>
              <th className="zahl">Tage</th><th className="zahl">Wahlen je Tag</th><th className="zahl">erste / letzte Wahl Ø</th><th className="zahl">Abstand Ø</th><th className="zahl">aktiv</th><th>zuletzt</th>
            </tr></thead>
            <tbody>{personen.map((p) => (
              <tr key={p.id} style={{ cursor: 'default' }}>
                <td><b>{p.name}</b></td>
                <td className="zahl"><b>{p.wahlen}</b></td>
                <td className="zahl">{p.kunden}</td>
                <td className="zahl">{p.termine}</td>
                <td className="zahl">{p.kunden ? Math.round(100 * p.termine / p.kunden) + ' %' : '–'}</td>
                <td className="zahl">{p.nicht_erreicht}</td>
                <td className="zahl">{p.rueckruf}</td>
                <td className="zahl">{p.lehnt_ab}</td>
                <td className="zahl">{p.falsche_nummer}</td>
                <td className="zahl">{p.tage}</td>
                <td className="zahl">{p.tage ? zahlDe(p.wahlen / p.tage) : '–'}</td>
                <td className="zahl">{p.erste_schnitt ?? '–'} / {p.letzte_schnitt ?? '–'}</td>
                <td className="zahl">{p.abstand_min == null ? '–' : `${zahlDe(p.abstand_min)} min`}</td>
                <td className="zahl">{p.aktive_stunden == null ? '–' : `${zahlDe(p.aktive_stunden)} h`}</td>
                <td className="klein">{zeitDe(p.zuletzt)}</td>
              </tr>))}</tbody>
          </table>
        </div>
      )}
      <p className="klein leise">
        Wahlen: Klicks auf „Anrufen“. Kunden: verschiedene Aufträge. Termine: am Telefon gebucht. Quote: Termine je angerufenem Kunden.
        Abstand: Mittelwert (Median) zwischen zwei Wahlen am selben Tag, Pausen über 60 Minuten zählen nicht. Aktiv: Summe der Abstände bis 15 Minuten.
        Ob und wie lange ein Gespräch in Webex lief, sieht die Plattform nicht.
      </p>

      {!!namen.length && (
        <>
          <div className="klein" style={{ fontWeight: 600, marginTop: 12 }}>Wahlen je Stunde</div>
          <div className="rollt">
            <table className="liste" data-stapeln="nein">
              <thead><tr><th>Mitarbeiter</th>{spalten.map((h) => <th key={h} className="zahl">{String(h).padStart(2, '0')}</th>)}</tr></thead>
              <tbody>{namen.map((n) => (
                <tr key={n} style={{ cursor: 'default' }}><td>{n}</td>{spalten.map((h) => {
                  const w = Number(stunden.find((s) => s.name === n && Number(s.stunde) === h)?.wahlen ?? 0);
                  return <td key={h} className="zahl" style={{ background: w ? `rgba(31,56,100,${0.12 + 0.6 * w / maxStunde})` : undefined, color: w / maxStunde > 0.6 ? '#fff' : undefined }}>{w || ''}</td>;
                })}</tr>))}</tbody>
            </table>
          </div>
        </>
      )}

      {!!d?.tage?.length && (
        <>
          <div className="klein" style={{ fontWeight: 600, marginTop: 12 }}>Je Tag</div>
          <table className="liste" data-stapeln="nein">
            <thead><tr><th>Tag</th><th>Mitarbeiter</th><th className="zahl">Wahlen</th><th className="zahl">Termine</th><th className="zahl">nicht erreicht</th><th className="zahl">erste / letzte Wahl</th></tr></thead>
            <tbody>{d.tage.map((t: any, i: number) => (
              <tr key={i} style={{ cursor: 'default' }}><td className="klein">{tagDe(t.tag)}</td><td>{t.name}</td><td className="zahl">{t.wahlen}</td><td className="zahl">{t.termine}</td><td className="zahl">{t.nicht_erreicht}</td><td className="zahl klein">{t.erste ?? '–'} / {t.letzte ?? '–'}</td></tr>))}</tbody>
          </table>
        </>
      )}
    </Karte>
  );
}
